import { render, staticRenderFns } from "./TabGroup.vue?vue&type=template&id=1b4bcda4"
import script from "./TabGroup.vue?vue&type=script&lang=js"
export * from "./TabGroup.vue?vue&type=script&lang=js"
import style0 from "./TabGroup.vue?vue&type=style&index=0&id=1b4bcda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports